import React from "react";
import { Tooltip } from "@fluentui/react-components";
import Input from "../input/customInput/CustomInput";
import { CalendarIcon } from "../../../modules/default-svg";
import styles from "./DateField.module.scss";

/**
 * A date the user can type in or pick from a calendar, the same field the forms of the app use. The value and what
 * it reports are written yyyy-MM-dd; it reports nothing until what was typed is a whole date. A `tooltip` says what
 * the date is for.
 */
export default function DateField({ value, onChange, tooltip, minDate, maxDate, className = "" }) {
  const field = (
    <div className={`${styles.dateField} ${className}`}>
      <Input type="date" icon={<CalendarIcon />} value={value} handleChange={onChange} minDate={minDate} maxDate={maxDate} />
    </div>
  );

  return tooltip ? (
    <Tooltip content={tooltip} relationship="description" positioning="above">
      {field}
    </Tooltip>
  ) : (
    field
  );
}
